import React, { useState, useEffect } from 'react';
import { supabase } from './supabaseClient';
import { t } from './i18n';

// ============================================================
// Panoul TikTok, mutat din compozitorul vechi (App.js, ~2760–2865).
//
// SE MUTA IDENTIC FUNCTIONAL. Fiecare camp de aici exista dintr-un motiv de
// recenzie TikTok, nu de gust, si de aia nu se redeseneaza si nu se
// „simplifica" niciunul:
//
//   1. Setarile contului se citesc CAND SE DESCHIDE ecranul de postare, nu mai
//      devreme. TikTok cere asta explicit: intre timp omul poate sa-si fi
//      schimbat setarile din aplicatie.
//   2. Lista de confidentialitate NU are valoare implicita. Omul trebuie sa
//      aleaga singur cine vede postarea; o valoare presetata ar fi o alegere
//      facuta in locul lui.
//   3. Lista e construita din elemente de pagina, nu dintr-un <select> nativ.
//      Lista nativa a sistemului NU apare in inregistrarile de ecran, iar
//      recenzia TikTok se face pe filmare: ce nu se vede, nu exista.
//   4. Cele trei bife de interactiune pornesc NEBIFATE, si se sting de tot
//      daca insusi contul le are oprite.
//   5. Declaratia de la final ramane in ENGLEZA, cuvant cu cuvant. E textul
//      cerut de TikTok, nu o explicatie pentru utilizator, si nu se traduce.
//   6. Continutul de brand nu poate fi privat: daca se bifeaza dupa ce s-a
//      ales „Doar eu", alegerea cade si trebuie refacuta.
//
// Singura diferenta fata de ecranul vechi e imbracamintea: acolo erau stiluri
// scrise in linie, aici sunt clasele v2. Niciun camp, nicio regula, nicio
// validare nu s-a schimbat.
// ============================================================

// Valorile cu care porneste panoul. Confidentialitatea porneste GOALA — vezi 2.
export const TIKTOK_GOL = {
  privacy: '',
  comentarii: false,
  duet: false,
  stitch: false,
  comercial: false,
  brandPropriu: false,
  brandContent: false,
};

// Ce se trimite la publicare. Aceleasi campuri ca in `campuriTikTok` din App.js,
// ca sa nu ajunga cele doua compozitoare sa trimita altceva pentru aceleasi bife.
export function campuriTikTok(tt) {
  return {
    tiktok_privacy_level: tt.privacy || null,
    tiktok_disable_comment: !tt.comentarii,
    tiktok_disable_duet: !tt.duet,
    tiktok_disable_stitch: !tt.stitch,
    tiktok_brand_content_toggle: tt.comercial && tt.brandContent,
    tiktok_brand_organic_toggle: tt.comercial && tt.brandPropriu,
  };
}

function etichetaConfid(o) {
  if (o === 'PUBLIC_TO_EVERYONE') return t('tiktok', 'privPublic');
  if (o === 'FOLLOWER_OF_CREATOR') return t('tiktok', 'privUrmaritori');
  if (o === 'MUTUAL_FOLLOW_FRIENDS') return t('tiktok', 'privPrieteni');
  if (o === 'SELF_ONLY') return t('tiktok', 'privDoarEu');
  return o;
}

// Ce opreste trimiterea. Scoase din `poateTrimite` (App.js:2509) ca sa poata fi
// chemate si de aici, si de butonul de publicare din Faza 6, fara sa se
// dubleze regula in doua locuri.
export function opreliștiTikTok(tt, info, durataSec) {
  const opriri = [];
  if (!tt.privacy) opriri.push({ cod: 'faraConfid' });
  const max = info && info.durata_maxima_sec;
  if (max && durataSec && durataSec > max) {
    opriri.push({
      cod: 'videoPreaLung',
      max: Math.round(max / 60),
      are: Math.ceil(durataSec / 60),
    });
  }
  return opriri;
}

export default function PanouTikTok({ clientId, tt, onSchimba, durataSec, onInfo }) {
  const [info, setInfo] = useState(null);
  const [incarca, setIncarca] = useState(false);
  const [eroare, setEroare] = useState('');
  const [listaDeschisa, setListaDeschisa] = useState(false);

  // Setarile contului ies si in afara panoului (Faza 6, Pasul 3), ca lista de
  // lipsuri de pe card sa cheme ACEEASI `opreliștiTikTok` cu aceleasi date. Nu
  // schimba niciun camp si nicio regula de mai sus: doar spune ce a citit.
  useEffect(() => {
    if (onInfo) onInfo({ info, eroare, incarca });
  }, [info, eroare, incarca, onInfo]);

  // 1. Citirea setarilor contului, la deschiderea ecranului.
  useEffect(() => {
    if (!clientId) { setInfo(null); setEroare(''); return; }
    let activ = true;
    setIncarca(true); setEroare(''); setInfo(null);
    (async () => {
      const { data, error } = await supabase.functions.invoke(
        'tiktok-creator-info', { body: { client_id: parseInt(clientId, 10) } },
      );
      if (!activ) return;
      if (error || (data && data.error)) {
        setEroare((data && (data.detail || data.error)) || (error && error.message) || 'eroare');
      } else {
        setInfo(data);
      }
      setIncarca(false);
    })();
    return () => { activ = false; };
  }, [clientId]);

  // 6. Continutul de brand nu poate fi privat.
  useEffect(() => {
    if (tt.brandContent && tt.privacy === 'SELF_ONLY') onSchimba({ ...tt, privacy: '' });
  }, [tt, onSchimba]);

  function pune(camp, valoare) {
    onSchimba({ ...tt, [camp]: valoare });
  }

  if (incarca) {
    return (
      <section className="v2-tt">
        <h3 className="v2-tt-titlu">{t('tiktok', 'panouTitlu')}</h3>
        <p className="v2-tt-asteapta">{t('tiktok', 'seIncarcaCont')}</p>
      </section>
    );
  }

  if (eroare) {
    return (
      <section className="v2-tt">
        <h3 className="v2-tt-titlu">{t('tiktok', 'panouTitlu')}</h3>
        <p className="v2-tt-eroare">⚠️ {t('tiktok', 'eroareCont')} {eroare}</p>
      </section>
    );
  }

  if (!info) return null;

  const opriri = opreliștiTikTok(tt, info, durataSec);
  const interactiuni = [
    { cheie: 'permiteComentarii', camp: 'comentarii', oprit: info.comentarii_oprite },
    { cheie: 'permiteDuet', camp: 'duet', oprit: info.duet_oprit },
    { cheie: 'permiteStitch', camp: 'stitch', oprit: info.stitch_oprit },
  ];

  return (
    <section className="v2-tt">
      <h3 className="v2-tt-titlu">{t('tiktok', 'panouTitlu')}</h3>

      <div className="v2-tt-cutie">

        <div className="v2-tt-cont">
          {info.avatar && <img src={info.avatar} alt="" className="v2-tt-avatar" />}
          <div>
            <div className="v2-tt-nume">{info.nume}</div>
            {info.utilizator && <div className="v2-tt-user">@{info.utilizator}</div>}
          </div>
        </div>

        {/* 2 si 3: fara valoare implicita, si construita din elemente de pagina. */}
        <div className="v2-tt-grup">
          <div className="v2-tt-eticheta">{t('tiktok', 'confidentialitate')}</div>
          <div className="v2-tt-lista-loc">
            <button
              type="button"
              className={tt.privacy ? 'v2-tt-ales' : 'v2-tt-ales gol'}
              onClick={() => setListaDeschisa(v => !v)}
              aria-expanded={listaDeschisa}
            >
              <span>{tt.privacy ? etichetaConfid(tt.privacy) : t('tiktok', 'alege')}</span>
              <span className="v2-tt-sageata">{listaDeschisa ? '▲' : '▼'}</span>
            </button>
            {listaDeschisa && (
              <div className="v2-tt-lista">
                {(info.optiuni_confidentialitate || []).map(o => {
                  const blocat = o === 'SELF_ONLY' && tt.comercial && tt.brandContent;
                  return (
                    <button
                      key={o}
                      type="button"
                      disabled={blocat}
                      className={tt.privacy === o ? 'v2-tt-optiune aleasa' : 'v2-tt-optiune'}
                      onClick={() => { pune('privacy', o); setListaDeschisa(false); }}
                    >
                      {etichetaConfid(o)}
                      {blocat && <span className="v2-tt-mic"> ({t('tiktok', 'brandNuPrivat')})</span>}
                    </button>
                  );
                })}
              </div>
            )}
          </div>
          {tt.comercial && tt.brandContent && (
            <p className="v2-tt-nota">{t('tiktok', 'brandNuPrivat')}</p>
          )}
        </div>

        {/* 4: pornesc nebifate; stinse de tot daca insusi contul le are oprite. */}
        <div className="v2-tt-grup">
          <div className="v2-tt-eticheta">{t('tiktok', 'interactiuni')}</div>
          {interactiuni.map(x => (
            <label key={x.camp} className={x.oprit ? 'v2-tt-bifa stinsa' : 'v2-tt-bifa'}>
              <input
                type="checkbox"
                checked={tt[x.camp] && !x.oprit}
                disabled={x.oprit}
                onChange={e => pune(x.camp, e.target.checked)}
              />
              {t('tiktok', x.cheie)}
              {x.oprit && <span className="v2-tt-mic"> ({t('tiktok', 'opritDinCont')})</span>}
            </label>
          ))}
        </div>

        <div className="v2-tt-grup">
          <label className="v2-tt-bifa tare">
            <input
              type="checkbox"
              checked={tt.comercial}
              onChange={e => pune('comercial', e.target.checked)}
            />
            {t('tiktok', 'comercial')}
          </label>
          <p className="v2-tt-explic">{t('tiktok', 'comercialExplic')}</p>
          {tt.comercial && (
            <div className="v2-tt-indent">
              <label className="v2-tt-bifa">
                <input
                  type="checkbox"
                  checked={tt.brandPropriu}
                  onChange={e => pune('brandPropriu', e.target.checked)}
                />
                {t('tiktok', 'brandPropriu')}
              </label>
              <label className="v2-tt-bifa">
                <input
                  type="checkbox"
                  checked={tt.brandContent}
                  onChange={e => pune('brandContent', e.target.checked)}
                />
                {t('tiktok', 'brandContent')}
              </label>
            </div>
          )}
        </div>

        {/* 5: textul cerut de TikTok, in engleza, cuvant cu cuvant. Nu se traduce. */}
        <div className="v2-tt-declaratie">
          {tt.comercial && tt.brandContent
            ? "By posting, you agree to TikTok's Branded Content Policy and Music Usage Confirmation."
            : "By posting, you agree to TikTok's Music Usage Confirmation."}
          <div className="v2-tt-procesare">{t('tiktok', 'procesare')}</div>
        </div>

        {opriri.length > 0 && (
          <ul className="v2-tt-opriri">
            {opriri.map(o => (
              <li key={o.cod}>
                {o.cod === 'faraConfid'
                  ? t('tiktok', 'alegeConfid')
                  : t('tiktok', 'videoPreaLung', { max: o.max, are: o.are })}
              </li>
            ))}
          </ul>
        )}

      </div>
    </section>
  );
}
